import { AppMode, IApp, IUpsertAppRequest } from '@bprotsyk/aso-core';
import { emptyAppState } from 'constants/app-initial';

export function createOfferwallAppState(app?: IApp): IApp | IUpsertAppRequest {
  const source = app || emptyAppState;
  const state = {
    ...source,
    appMode: AppMode.OFFERWALL,
    offerwallParams: {
      ...emptyAppState.offerwallParams,
      ...(source.offerwallParams || {}),
      version: 'MFO',
      defaultLogicEnabled: true,
    },
  } as IApp | IUpsertAppRequest;
  delete (state as any).campaignNaming;
  return state;
}
